import request from '@/utils/request';
const path = 'material/report/jrtt';

/**
 * 获取素材视频图表接口
 * @param {*} data 参数
 * @returns
 */
export function getMaterialVideoReportApi(data) {
  return request({
    url: `${path}/video`,
    method: 'GET',
    params: data,
  });
}

/**
 * 获取素材图片图表接口
 * @param {*} data 参数
 * @returns
 */
export function getMaterialImageReportApi(data) {
  return request({
    url: `${path}/image`,
    method: 'GET',
    params: data,
  });
}

/**
 * 获取素材标题图表接口
 * @param {*} data 参数
 * @returns
 */
export function getMaterialTitleReportApi(data) {
  return request({
    url: `${path}/title`,
    method: 'GET',
    params: data,
  });
}

/**
 * 获取素材报表
 * @param {*} data 参数
 * @returns
 */
export function getMaterialTableReportApi(data) {
  return request({
    url: `${path}/table`,
    method: 'GET',
    params: data,
  });
}
